// src/store/classroomActions.js

import {
  GET_CLASSROOMS,
  GOT_CLASSROOMS,
  FETCH_CLASSROOMS_ERROR,
  GET_MEDIA,
  GOT_MEDIA,
  FETCH_MEDIA_ERROR,
  GET_TRANSCRIPTION,
  GOT_TRANSCRIPTION,
  FETCH_TRANSCRIPTION_ERROR,
  GET_OVERALL_DATA,
  GOT_OVERALL_DATA,
  FETCH_OVERALL_DATA_ERROR
} from "./actionTypes";

export const getClassrooms = () => ({
  type: GET_CLASSROOMS,
});

export const gotClassrooms = (classrooms) => ({
  type: GOT_CLASSROOMS,
  payload: classrooms,
});

export const fetchClassroomsError = (error) => ({
  type: FETCH_CLASSROOMS_ERROR,
  payload: error,
});

export const getMedia = (class_id) => ({ type: GET_MEDIA, payload: class_id });
export const gotMedia = (Mediadata) => ({
  type: GOT_MEDIA,
  payload: Mediadata,
});
export const fetchMediaError = (error) => ({
  type: FETCH_MEDIA_ERROR,
  payload: error,
});

export const gettranscription = (file_id, file_type) => ({
  type: GET_TRANSCRIPTION,
  payload: { file_id, file_type },
});
export const gottranscripton = (data) => ({
  type: GOT_TRANSCRIPTION,
  payload: data,
});
export const fetchTranscriptionError = (error) => ({
  type: FETCH_TRANSCRIPTION_ERROR,
  payload: error,
});

export const getoveralldata = () => ({ type: GET_OVERALL_DATA });
export const gotoveralldata = (data) => ({
  type: GOT_OVERALL_DATA,
  payload: data,
});
export const fetchoveralldataError = (error) => ({
  type: FETCH_OVERALL_DATA_ERROR,
  payload: error,
});
